module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/231.1738457c.png";